// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__26DLD","approved":"Status_approved__23YWl","rejected":"Status_rejected__3FEka","expired":"Status_expired__3RCtc","label":"Status_label__1D_b_"};